import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const objectOptions = [
  'Domingo',
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
];

export const options = objectOptions.map((label, value) => ({ label, value: `${value}` }));

export const strategy = optionsToStrategy(options);
